const features = (state = [], action) => state

export default features



// WEBPACK FOOTER //
// ../src/reducers/features.js